import { DEFAULT_FIELD_ERROR } from './constants';
const isNotEmpty = (value) => Boolean(value?.trim());
const timeRegexp = /^([01]\d|2[0-3]):([0-5]\d)$/;
const isMatchingRegexp = (value) => timeRegexp.test(value);
const dateRegexp = /^\d{2}\.\d{2}\.\d{4}$/;
const MAX_FLIGHT_DURATION_MINUTES = 24 * 60;
const parseDateTime = (date, time) => {
    const [day, month, year] = date.split('.').map(Number);
    const [hours, minutes] = time.split(':').map(Number);
    return new Date(year, month - 1, day, hours, minutes).getTime();
};
export const validateFlightTime = (value, compareTo) => {
    const validation = [
        {
            validator: isNotEmpty,
            message: DEFAULT_FIELD_ERROR,
        },
        {
            validator: isMatchingRegexp,
            message: 'Введите время в формате ЧЧ:ММ',
        },
    ];
    const error = validation.find(({ validator }) => !validator(value));
    if (error) {
        return { error: error.message };
    }
    if (compareTo && compareTo.dateFrom === compareTo.dateTo) {
        if (isMatchingRegexp(compareTo.timeFrom) && isMatchingRegexp(value)) {
            const [hoursFrom, minutesFrom] = compareTo.timeFrom
                .split(':')
                .map(Number);
            const [hoursTo, minutesTo] = value.split(':').map(Number);
            const timeFromMinutes = hoursFrom * 60 + minutesFrom;
            const timeToMinutes = hoursTo * 60 + minutesTo;
            if (timeToMinutes <= timeFromMinutes) {
                return {
                    error: 'Время прилёта должно быть позже времени вылета',
                };
            }
        }
    }
    if (compareTo &&
        dateRegexp.test(compareTo.dateFrom) &&
        dateRegexp.test(compareTo.dateTo) &&
        isMatchingRegexp(compareTo.timeFrom) &&
        isMatchingRegexp(value)) {
        const departure = parseDateTime(compareTo.dateFrom, compareTo.timeFrom);
        const arrival = parseDateTime(compareTo.dateTo, value);
        const durationMinutes = (arrival - departure) / 1000 / 60;
        if (durationMinutes > MAX_FLIGHT_DURATION_MINUTES) {
            return {
                error: 'Прилёт должен быть не позже 24 часов с момента вылета',
            };
        }
    }
    return { error: null };
};
